import { MotifIcon, MotifTooltip } from '@ey-xd/motif-react'
import { MotifCheckbox } from "@ey-xd/motif-react";
import React from 'react'
import iconSvg from '../../assets/icons/icon.svg.json';

const ListOptionSelect = (props: any) => {
    const { title, description, checked, onChange } = props;
    const renderInfo = () => {
        return (
            <>
                <MotifTooltip hideArrow={true} allowHover={true} allowClick={false} flip={true} placement={'bottom'} trigger={
                    <MotifIcon src={iconSvg['info-icon']} className="!w-5" title="Info" />
                }>{description}</MotifTooltip>

            </>
        )
    }
    return (
        <div className="flex justify-between items-center p-3 !bg-[#8888881a]">
            <MotifCheckbox
                id={title}
                name={title}
                checked={checked}
                onChange={onChange}
            >
                {title}
            </MotifCheckbox>
            {renderInfo()}
        </div>
    )
}

export default ListOptionSelect